/**
 * What a settings save sends (batch 8 T12c1, #3033): the mode always, and the order email and the document language only when the user
 * changed them. An untouched value is left out, so a save can never overwrite something this screen did not show or the user did not
 * touch; an emptied one is sent as `null` (a clear).
 */

import type {
  DocumentLanguage,
  SupplierDispatchMode,
  SupplierDispatchSettings,
  SupplierDispatchSettingsBody,
} from './dispatchTypes';

/** The "not set" choice of the language selector. */
export const UNSET = '';

/** Only what changed: the mode always, the address and the language only when they differ from what the server holds. */
export function buildSettingsBody(
  loaded: Pick<SupplierDispatchSettings, 'orderEmail' | 'orderDocumentLanguage'>,
  draft: {
    mode: SupplierDispatchMode;
    orderEmail: string;
    language: DocumentLanguage | typeof UNSET;
  }
): SupplierDispatchSettingsBody {
  const body: SupplierDispatchSettingsBody = { mode: draft.mode };
  const email = draft.orderEmail.trim();
  if (email !== (loaded.orderEmail ?? '')) body.orderEmail = email === '' ? null : email;
  const language = draft.language === UNSET ? null : draft.language;
  if (language !== loaded.orderDocumentLanguage) body.orderDocumentLanguage = language;
  return body;
}
